'use client';

import classNames from 'classnames';
import React from 'react';
import { formatAbbreviatedNumber } from '../../utils/formatAbbreviatedNumber';

interface AbbreviatedNumberProps {
  /**
   * The number to format
   */
  value?: number;

  /**
   * Optional CSS class name
   */
  className?: string;

  /**
   * Whether to show the exact number as a tooltip on hover
   */
  showTooltip?: boolean;
}

/**
 * A component that displays a number in abbreviated format (e.g., 2.5k, 1M)
 * with optional tooltip showing the exact value.
 */
export const AbbreviatedNumber: React.FC<AbbreviatedNumberProps> = ({
  value,
  className = '',
  showTooltip = true,
}) => {
  const formattedValue = formatAbbreviatedNumber(value);

  // Format the exact number for tooltip
  const exactValue = React.useMemo(() => {
    if (value === undefined || value === null) return '';
    return value.toLocaleString();
  }, [value]);

  return (
    <span
      className={classNames(className, 'tooltip')}
      data-tip={showTooltip && value && value > 1000 ? exactValue : undefined}>
      {formattedValue}
    </span>
  );
};
